import { apiInstagramChat as http } from '../../../../http';
class ChatConfigurationSignaling {
  async get() {
    const result = await http.get('/configurations/conversation-signal');
    return result.data.data;
  }

  async update(data) {
    await http.put('/configurations/conversation-signal', data);
  }
}

export const ChatConfigurationSignalingService =
  new ChatConfigurationSignaling();
